import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function HookSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-white py-20 md:py-28" data-id="element-110">
      <div className="max-w-4xl mx-auto px-6" data-id="element-111">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} data-id="element-112">
          <p className="text-[#B794C0] font-medium text-lg mb-4 tracking-wide uppercase" data-id="element-113">
            Sabes exactamente de qué hablo
          </p>

          <div className="space-y-6 text-lg md:text-xl text-[#4A4A4A] leading-relaxed" data-id="element-114">
            <p data-id="element-115">
              Te sientas a trabajar. Tienes una idea brillante. Abres la
              laptop...
            </p>

            <div className="bg-[#F3EDF7] rounded-2xl p-6 md:p-8 space-y-3" data-id="element-116">
              <p className="font-['Playfair_Display'] text-xl md:text-2xl italic text-[#2D2D2D]" data-id="element-117">
                "Mamá, tengo hambre".
              </p>
              <p className="font-['Playfair_Display'] text-xl md:text-2xl italic text-[#2D2D2D]" data-id="element-118">
                "Mamá, no encuentro mi juguete".
              </p>
              <p className="font-['Playfair_Display'] text-xl md:text-2xl italic text-[#2D2D2D]" data-id="element-119">
                "Mamá, me aburro".
              </p>
            </div>

            <p data-id="element-120">Cierras la laptop. Suspiras. Atiendes.</p>

            <p data-id="element-121">Intentas volver, pero el hilo de la idea ya se rompió.</p>

            <p className="text-[#2D2D2D] font-medium" data-id="element-122">
              Al final del día, el balance es agotador: trabajaste "a medias"
              todo el día, no avanzaste en lo importante, y te queda esa
              sensación amarga de no ser ni la profesional que quieres ser, ni
              la madre presente que deseas ser.
            </p>
          </div>
        </motion.div>

        {/* Before/After Image */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: 'easeOut'
      }} className="mt-12" data-id="element-123">
          <img src="https://cdn.magicpatterns.com/uploads/jbnd3nytLWjjJvx2bzSWDJ/Imagen_para_pagina_de_ventas.png" alt="Antes y después: del caos a la productividad" className="w-full rounded-2xl shadow-xl" data-id="element-124" />
        </motion.div>

        {/* Key insight */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7,
        delay: 0.4,
        ease: 'easeOut'
      }} className="mt-12 border-l-4 border-[#E07A5F] pl-6" data-id="element-125">
          <p className="font-['Playfair_Display'] text-2xl md:text-3xl text-[#2D2D2D] leading-snug" data-id="element-126">
            El problema no es que te falte tiempo.
          </p>
          <p className="font-['Playfair_Display'] text-2xl md:text-3xl text-[#2D2D2D] leading-snug mt-2" data-id="element-127">
            El problema es que intentas usar una agenda de "madre sin hijos" en
            una vida que desborda.
          </p>
        </motion.div>
      </div>
    </section>;
}